// extracted by mini-css-extract-plugin
export default {"wrapper":"A_ContentLink_wrapper__z-fbB","copy_button":"A_ContentLink_copy_button__EtbOR","link":"A_ContentLink_link__cKjP6"};